// extracted by mini-css-extract-plugin
module.exports = {"splitRow":"splitInfoCard-module--splitRow--Rc6xH","colButton":"splitInfoCard-module--colButton--1gKkE"};